import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { NgForm, AbstractControl, ValidationErrors, Validators } from '@angular/forms';

@Component({
    selector: 're-keycloak-import-confirmation-dialog',
    templateUrl: './keycloak-import-confirmation-dialog.component.html',
    styleUrls: ['./keycloak-import-confirmation-dialog.component.scss'],
    standalone: false
})
export class KeycloakImportConfirmationDialogComponent {
  @ViewChild("form")
  form: NgForm;

  numberOfUsers = 0;

  domain: string;
  crmID: string;

  lowerCase: boolean;
  upperCase: boolean;
  numberCase: boolean;
  minLengthCase: boolean;
  specialCharacterCase: boolean;

  domainRegExPattern = /@(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/i;

  constructor(private activeModal: NgbActiveModal, private router: Router) { }

  ngOnInit(): void { }

  accept() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }
}
